/*
  © 2024 KondaSoft
  https://www.kondasoft.com
*/

console.log('KS BootShop - Free Shopify Theme by KondaSoft.com | Learn more at https://www.kondasoft.com')

// Init Bootstrap tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]')
  .forEach((el) => new window.bootstrap.Tooltip(el))

// Init Bootstrap popovers
document.querySelectorAll('[data-bs-toggle="popover"]')
  .forEach((el) => new window.bootstrap.Popover(el))

// Debouce
window.theme.debounce = function (callback, wait = 200) {
  let timeout
  return (...args) => {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => callback.apply(context, args), wait)
  }
}

// Throttle
window.theme.throttle = function (callback, timeFrame = 200) {
  let lastTime = 0
  return function () {
    const now = Date.now()
    if (now - lastTime >= timeFrame) {
      callback()
      lastTime = now
    }
  }
}

// Create cookie
window.theme.createCookie = function (name, value, days) {
  let date, expires
  if (days) {
    date = new Date()
    date.setDate(date.getDate() + days)
    expires = '; expires=' + date.toUTCString()
  } else {
    expires = ''
  }
  document.cookie = name + '=' + value + expires + '; path=/'
}

// Detect scroll
window.addEventListener('scroll', () => {
  if (window.scrollY > 0) {
    document.documentElement.classList.add('has-scrolled')
  } else {
    document.documentElement.classList.remove('has-scrolled')
  }
})

// Calculate "xx time ago"
window.theme.calcTimeAgo = function (timestamp) {
  const now = new Date().getTime()
  const diff = now - timestamp

  let text

  if (diff < 60000) {
    text = window.theme.locales.times.moments
  } else if (diff < 3.6e+6) {
    const min = Math.round((diff) / 60000)
    text = min === 1
      ? `${min} ${window.theme.locales.times.minute}`
      : `${min} ${window.theme.locales.times.minutes}`
  } else if (diff < 8.64e+7) {
    const hours = Math.round((diff) / 3.6e+6)
    text = hours === 1
      ? `${hours} ${window.theme.locales.times.hour}`
      : `${hours} ${window.theme.locales.times.hours}`
  } else {
    const days = Math.round((diff) / 8.64e+7)
    text = days === 1
      ? `${days} ${window.theme.locales.times.day}`
      : `${days} ${window.theme.locales.times.days}`
  }

  return `${text} ${window.theme.locales.times.ago}`
}

// Format money
window.Shopify.formatMoney = function (cents, moneyFormat = window.Shopify.moneyFormat) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '')
  }

  let value = ''
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/

  function defaultOption (opt, def) {
    return (typeof opt === 'undefined' ? def : opt)
  }

  function formatWithDelimiters (number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    const parts = number.split('.')
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
    const cents = parts[1] ? (decimal + parts[1]) : ''

    return dollars + cents
  }

  switch (moneyFormat.match(placeholderRegex)[1]) {
  case 'amount':
    value = formatWithDelimiters(cents, 2)
    break
  case 'amount_no_decimals':
    value = formatWithDelimiters(cents, 0)
    break
  case 'amount_with_comma_separator':
    value = formatWithDelimiters(cents, 2, '.', ',')
    break
  case 'amount_no_decimals_with_comma_separator':
    value = formatWithDelimiters(cents, 0, '.', ',')
    break
  }

  return moneyFormat.replace(placeholderRegex, value)
}

// Resize images
window.Shopify.resizeImage = function (src, size, crop = '') {
  return src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
      if (crop.length) {
        crop = `_crop_${crop}`
      }
      return `_${size}${crop}${match}`
    })
}

// Shopify's callenge page
document.querySelector('.btn.shopify-challenge__button')
  ?.classList.add('btn-primary')

// Shopify's errors messages
const errors = document.querySelector('.errors')
if (errors) {
  errors.classList.add('alert', 'alert-danger')
}

// Wrap Shopify's section apps within a container
document.querySelectorAll('.shopify-section > .shopify-app-block').forEach(elem => {
  elem.classList.add('container')
})

// Detect viewport with the Intersection Observer API
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('viewport-entered')
    } else {
      entry.target.classList.remove('viewport-entered')
    }
  })
}, { threshold: 0.4 })

document.querySelectorAll('.viewport-detect').forEach((el) => {
  observer.observe(el)
})

// Swiper Slider
class SwiperSlider extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.init()
      }
    })
  }

  init () {
    this.slider = new window.Swiper(this.querySelector('.swiper'), {
      speed: this.speed,
      autoplay: this.autoplay,
      navigation: this.navigation,
      pagination: this.pagination,
      scrollbar: this.scrollbar,
      breakpoints: this.breakpoints,
      rewind: true
    })
  }

  speed = Number(this.dataset.sliderSpeed)

  autoplay = this.dataset.sliderAutoplay === '0'
    ? undefined
    : { delay: Number(this.dataset.sliderAutoplay) * 1000 }

  navigation = {
    enabled: this.dataset.sliderNavigation === 'true',
    prevEl: '.swiper-button-prev',
    nextEl: '.swiper-button-next'
  }

  pagination = {
    enabled: this.dataset.sliderPagination === 'true',
    el: '.swiper-pagination',
    type: 'bullets',
    dynamicBullets: true,
    dynamicMainBullets: 2,
    renderFraction: function (currentClass, totalClass) {
      return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
    }
  }

  scrollbar = {
    enabled: this.dataset.sliderScrollbar === 'true',
    el: this.querySelector('.swiper-scrollbar'),
    draggable: true
  }

  breakpoints = {
    0: { slidesPerView: Number(this.dataset.breakpointMobile) },
    600: { slidesPerView: Number(this.dataset.breakpointTablet) },
    1200: { slidesPerView: Number(this.dataset.breakpointDesktop) }
  }
}
customElements.define('swiper-slider', SwiperSlider)

/*
  Localization form
*/
document.querySelectorAll('.shopify-localization-form button').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.closest('form').querySelector('[name="country_code"]').value = btn.dataset.isoCode
    btn.closest('form').submit()
  })
})

document.addEventListener('DOMContentLoaded', function () {

  // Handle nested dropdowns (Bootstrap 5)
  document.querySelectorAll('.dropdown-submenu > .dropdown-toggle').forEach(function (trigger) {

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const submenu = this.nextElementSibling;

      if (!submenu) return;

      // Close other open submenus
      const parentMenu = this.closest('.dropdown-menu');
      parentMenu.querySelectorAll('.dropdown-menu.show').forEach(function (openMenu) {
        if (openMenu !== submenu) {
          openMenu.classList.remove('show');
        }
      });

      submenu.classList.toggle('show');
    });

  });

  // Close all submenus when main dropdown closes
  document.querySelectorAll('.dropdown').forEach(function (dropdown) {
    dropdown.addEventListener('hide.bs.dropdown', function () {
      this.querySelectorAll('.dropdown-menu.show').forEach(function (menu) {
        menu.classList.remove('show');
      });
    });
  });

});
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.color-swatch-btn');
  if (!btn) return;

  const input = document.getElementById(btn.dataset.target);
  if (!input || input.disabled) return;

  input.checked = !input.checked;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});


/* ================================
   CART PROGRESS BAR – US OFFERS
   (KONDASOFT SAFE)
================================ */

document.addEventListener('DOMContentLoaded', () => {
  updateCartProgressKS();

  // Re-run on AJAX cart updates
  document.addEventListener('cart:updated', updateCartProgressKS);
  document.addEventListener('cart:refresh', updateCartProgressKS);
});

function updateCartProgressKS() {
  const fill = document.querySelector('.progress-fill');
  const dots = document.querySelectorAll('.dot');

  if (!fill || dots.length < 3) return;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const total = cart.total_price / 100; // USD

      // Reset
      dots.forEach(dot => dot.classList.remove('active'));

      let progress = 0;

      if (total <= 39) {
        // From $0 → $39  (0% → 0%)
        progress = 0;
      } 
      else if (total > 39 && total < 49) {
        // $39 → $49 maps to 0% → 50%
        progress = ((total - 39) / (49 - 39)) * 50;
        dots[0].classList.add('active');
      } 
      else if (total >= 49 && total < 99) {
        // $49 → $99 maps to 50% → 100%
        progress = 50 + ((total - 49) / (99 - 49)) * 50;
        dots[0].classList.add('active');
        dots[1].classList.add('active');
      } 
      else {
        progress = 100;
        dots.forEach(dot => dot.classList.add('active'));
      }

      fill.style.width = progress + '%';
    })
    .catch(err => console.error('Cart progress error:', err));
}
/* =================================================
   CART PROGRESS BAR – LIVE (NO REFRESH REQUIRED)
   KondaSoft / BootShop – FINAL FIX
================================================= */

function updateCartProgressKS() {
  const fill = document.querySelector('.progress-fill');
  const dots = document.querySelectorAll('.dot');

  if (!fill || dots.length < 3) return;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const total = cart.total_price / 100; // USD

      // Reset
      dots.forEach(dot => dot.classList.remove('active'));

      let progress = 0;

      if (total <= 39) {
        progress = 0;
      }
      else if (total > 39 && total < 49) {
        progress = ((total - 39) / 10) * 50;
        dots[0].classList.add('active');
      }
      else if (total >= 49 && total < 99) {
        progress = 50 + ((total - 49) / 50) * 50;
        dots[0].classList.add('active');
        dots[1].classList.add('active');
      }
      else {
        progress = 100;
        dots.forEach(dot => dot.classList.add('active'));
      }

      fill.style.width = progress + '%';
    })
    .catch(() => {});
}

/* ---------- INITIAL RUN ---------- */
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(updateCartProgressKS, 300);
});

/* ---------- MUTATION OBSERVER (THE REAL FIX) ---------- */
const cartObserver = new MutationObserver(() => {
  updateCartProgressKS();
});

/* Observe cart page + cart drawer */
document.addEventListener('DOMContentLoaded', () => {
  const targets = [
    document.querySelector('.cart'),
    document.querySelector('.cart-drawer'),
    document.querySelector('#offcanvas-cart'),
    document.querySelector('[data-cart]')
  ];

  targets.forEach(target => {
    if (target) {
      cartObserver.observe(target, {
        childList: true,
        subtree: true
      });
    }
  });
});

